import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import classes from './restoreLogDialog.module.scss';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import { ReactComponent as Close } from '../../../assets/images/close.svg';

import { useOrganization } from '../../../hooks/entityHooks';

import { Subdivision } from '../../../types/subdivision';
import { Organization } from '../../../types/organization';

const useStyles = makeStyles({
  root: {
    background: '#FF7221',
    borderRadius: 0,
    width: 180,
    height: 50,
    color: 'white',
    textTransform: 'none',
    fontWeight: 550,
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    fontSize: 16,
    marginLeft: 10,
    '&:hover, &:focus': {
      background: '#FF7221',
    },
  },
  restore: {
    background: 'white',
    width: 180,
    height: 50,
    fontSize: 16,
    fontFamily: 'HelveticaNeueCyr',
    fontWeight: 550,
    color: '#FF7221',
    border: '1px solid #FF7221',
    borderRadius: 0,
    marginRight: 10,
    textTransform: 'none',
    '&:hover, &:focus': {
      background: '#FF7221',
      color: 'white',
      border: 'none',
    },
  },
});

type Points = {
  a: string;
  b: string;
  newParent: number;
  branch: { from: number[]; to: number[] };
  tree?: Subdivision;
  fromOrg: Organization;
  toOrg: Organization;
  id: number;
  isStuff: boolean;
};
type Props = {
  open: boolean;
  handleClose(): void;
  points: Points;
  handleUpdateEntity(entityId: number, type: number): Promise<void>;
  moveEntity(subdivisions: number[], organizations: number[]): void;
};

export const ChangeOrgDialog = ({
  handleClose,
  open,
  points,
  handleUpdateEntity,
  moveEntity,
}: Props) => {
  const [focus, setFocus] = useState(false);
  const { changeParent } = useOrganization();
  const style = useStyles();

  const changeParentSubdivision = async () => {
    await changeParent(points.newParent, points.id, points.isStuff);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        // fullWidth
        maxWidth="xs"
      >
        <DialogTitle>
          <div className={classes.dialog__dialogTitle}>
            <span>Перенос</span>
            <div
              className={classes.close}
              onMouseOver={(e) => setFocus(true)}
              onMouseOut={(e) => setFocus(false)}
              onClick={(e) => handleClose()}
            >
              {focus ? <FillClose /> : <Close />}
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className={classes.dialog__question}>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <p>
              Вы уверены, что хотите перенести из "{points.a}" в "{points.b}"?
            </p>
          </div>

          <div className={classes.dialog__buttons}>
            <Button className={style.restore} onClick={handleClose}>
              Отмена
            </Button>
            <Button
              className={style.root}
              onClick={() => {
                handleClose();
                changeParentSubdivision().then(() => {
                  !points.isStuff &&
                    handleUpdateEntity(points.id, 2).then(() => {
                      const { fromOrg, toOrg, branch, tree } = points;
                      const organizations = [fromOrg.id, toOrg.id];
                      const subdivisions = [
                        ...new Set([
                          ...branch.from,
                          ...branch.to,
                          ...(tree?.subdivisions
                            ? tree.subdivisions.map(
                                (subdivision: Subdivision) => subdivision.id,
                              )
                            : []),
                        ]),
                      ].filter(
                        (subdivisionId) =>
                          !organizations.includes(subdivisionId),
                      );

                      moveEntity(subdivisions, organizations);
                    });
                });
              }}
            >
              Подтвердить
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
